import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import App from './App.tsx'
import { ToastProvider } from './components/ui/Toast'
import { AccountProvider } from './components/account/AccountProvider'
import { CmsProvider } from './cms/CmsProvider'
import { registerGsap } from './animations/gsapAnimations'

registerGsap()

/* The catalogue changes when a car is sold or lands, which is a handful of
   times a week — so rows stay fresh for five minutes and a window refocus
   does not fire a wave of requests at the API. A failed request is retried
   once: past that it is the API that is down, not the network that blipped,
   and the visitor is better told than left spinning. */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      gcTime: 15 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Inside the query client, because signing out drops this person's
          own cached rows — the catalogue is public and is left alone. */}
      <AccountProvider>
        {/* What the pages are made of, and — inside the console's preview
            frame — the live wire to whoever is editing them. Above the router
            because the frame's own furniture is outlined too, and inside the
            query client because the layout is one more cached read. */}
        <CmsProvider>
          <ToastProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ToastProvider>
        </CmsProvider>
      </AccountProvider>
    </QueryClientProvider>
  </StrictMode>,
)
